<template>
  <div>
    <div id="passwordreset--modal">
      <transition name="fade" mode="out-in" :duration="500">
        <div class="modal-content">
          <passwordreset-header :lang-root="`${langRoot}`"/>
          <router-view :lang-root="`${langRoot}`"/>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Header from './PasswordResetHeader';

const name = 'password-reset';
export default {
    name,
    componentName: name,

    components: {
        [Header.name]: Header,
    },

    data() {
        return {
            langRoot: 'passwordReset',
        };
    },
};
</script>




// WEBPACK FOOTER //
// login/Components/PasswordReset.vue